import PopularDestinationsContainer from '../../../../components/containers/PopularDestinationsContainer';
import preloadCustomProps from '../../../utils/preloads/preloadPopularDestinationsProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'popular-destinations',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PopularDestinationsContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
